import Resources from '../Resources';
import { container, singleton } from 'tsyringe';

@singleton()
export default class TranslationService {
    private lang = 'en';
    public constructor(public resources?: Resources) {
        const savedLanguage = localStorage.getItem('selectedLanguage');
        if (savedLanguage) {
            this.lang = savedLanguage;
        }
    }

    public l(key: string, ...params: any[]): string {
        if (!this.resources) {
            console.warn(`TranslationService: resources not initialized, returning key: ${key}`);
            return key;
        }

        if (!this.resources.items || !this.resources.items.translations) {
            console.warn(`TranslationService: translations not loaded yet, returning key: ${key}`);
            return key;
        }

        const labels = this.resources.items.translations?.labels;
        if (!labels) {
            console.warn(`TranslationService: translation labels not available, returning key: ${key}`);
            return key;
        }

        let translation = labels[key];

        if (!translation && this.resources.items.translationsPL?.labels) {
            translation = this.resources.items.translationsPL.labels[key];
        }

        if (!translation) {
            console.warn(`TranslationService: translation not found for key: ${key}`);
            return key;
        }

        translation = translation.replace(/\\n/g, '\n');

        params.forEach((param, index) => {
            translation = translation.replace(`{${index}}`, param);
        });

        return translation;
    }


    public static translate(key: string, ...params: any[]): string {
        const service = container.resolve(TranslationService);
        return service.l(key, ...params);
    }

    public getLanguage(): string {
        return localStorage.getItem('selectedLanguage') || 'en';
    }

    public setLanguage(lang: string): void {
        this.lang = lang;
        localStorage.setItem('selectedLanguage', lang);
    }
}
